module.exports = __webpack_public_path__ + "images/b88643df3428cce0fd90494583c89f52.svg";